import DivChip from "./DivChip";
import { Box, Typography, Tooltip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "./footer.css";
import {
  YouTube,
  Instagram,
  LinkedIn,
  Email,
  WhatsApp,
} from "@mui/icons-material";

const Footer = () => {
  return (
    <>
      <div>
        <DivChip text="Contact Us"></DivChip>
        <Grid container>
          <Grid sm={12}>
            <Box variant="div" className="social-media">
              <Tooltip title="Instagram " sx={{ fontFamily: "roboto" }}>
                <a
                  target="_blank"
                  href="https://www.instagram.com/imaindco?igsh=aXdyM21uNTJ3YjEy"
                >
                  <Instagram
                    sx={{ color: "#49519A", margin: 1, fontSize: "44px" }}
                  />
                </a>
              </Tooltip>
              <Tooltip title="WhatsApp " sx={{ fontFamily: "roboto" }}>
                <a
                  target="_blank"
                  href="https://wa.me/09128891585?text=urlencodedtext"
                >
                  <WhatsApp
                    sx={{ color: "#49519A", margin: 1, fontSize: "45px" }}
                  />
                </a>
              </Tooltip>
              <Tooltip title="linkedin " sx={{ fontFamily: "roboto" }}>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/in/ima-ind-co-b50b06127"
                >
                  <LinkedIn
                    sx={{ color: "#49519A", margin: 1, fontSize: "45px" }}
                  />
                </a>
              </Tooltip>
              <Tooltip title="Email " sx={{ fontFamily: "roboto" }}>
                <a target="_blank" href="mailto:info@gmail.com">
                  <Email
                    sx={{ color: "#49519A", margin: 1, fontSize: "45px" }}
                  />
                </a>
              </Tooltip>
            </Box>
          </Grid>
          <Grid sm={12}>
            <Box className="footer-text">
              <Typography className="text-tel">www.imaind.com</Typography>
              <Typography className="text-tel">Tel:+98 9128891585</Typography>
              <Typography className="text-tel">Tel:+98 2188484749</Typography>
            </Box>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Footer;
